import { observable } from "mobx";
import Model from "@app/state/model/base";

export default class Image extends Model {
    @observable src = undefined;
    @observable width = undefined;
    @observable height = undefined;
}
